import React from 'react'
import PageHeader from '../../components/pageHeader/PageHeader'

const RefundPolicy = () => {
  return (
    <div>
      <PageHeader title={'Refund and Policy'}/>
      <h1>Refund and Policy</h1>
    </div>
  )
}

export default RefundPolicy
